module.exports = __webpack_public_path__ + "images/5cb4613b2ba3c5588f208d7e9a876d4ea16c6eee9ed714b9cc073cc710a23eb7.svg";